import type { Uid } from "@/helpers/utility/Id";
import { defineItemStore } from "../itemStore.store";
import type { StoreItem } from "../StoreItem";

export interface SceneFlowNode extends StoreItem {
  type: "sceneFlowNode";
  id: number;
  uid: Uid<"sceneFlowNode">;

  flowId: number;
  sceneId: number;

  visible: boolean;

  x: number;
  y: number;
};

const defaultSceneFlowNode: SceneFlowNode = {
  type: "sceneFlowNode",
  id: 0,
  uid: "sceneFlowNode_0",

  flowId: 0,
  sceneId: 0,

  visible: true,

  x: 0,
  y: 0,

  createdAt: -1
};

export const useSceneFlowNodeStore = defineItemStore("model/sceneFlowNodes", defaultSceneFlowNode, {
  getters: {
    byScene(state): { [sceneId: number]: Record<number, SceneFlowNode> } {
      const settings: { [sceneId: number]: Record<number, SceneFlowNode> } = {};
      for (const setting of Object.values(state.items)) {
        if (!settings[setting.sceneId]) {
          settings[setting.sceneId] = {};
        }
        settings[setting.sceneId][setting.flowId] = setting;
      }
      return settings;
    }
  },
  actions: {
    async updateOrCreate(data: Partial<SceneFlowNode> & { flowId: number; sceneId: number }) {
      const existing = this.byScene[data.sceneId]?.[data.flowId];
      if (existing) {
        return this.update({
          id: existing.id,
          ...data
        });
      }
      return this.create({
        ...defaultSceneFlowNode,
        ...data
      });
    }
  }
});
